// import React, { useState, useEffect } from "react";
// import Sidebar from "../../../Components/Sidebar";
// import TopNav from "../../../Components/TopNav";
// import {
//   addFaqServ,
//   updateFaqServ,
//   deleteFaqServ,
// } from "../../../services/faq.service";
// import { getContactListServ } from "../../../services/support.service";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";
// import { toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// import moment from "moment";
// import NoRecordFound from "../../../Components/NoRecordFound";
// function ContactQueryList() {
//   const [list, setList] = useState([]);
//   const [statics, setStatics] = useState(null);
//   const [payload, setPayload] = useState({
//     searchKey: "",
//     category: "",
//     pageNo: 1,
//     pageCount: 25,
//     sortByField: "",
//   });
//   const [showSkelton, setShowSkelton] = useState(false);
//   const handleGetContactListFunc = async () => {
//     if (list.length === 0) {
//       setShowSkelton(true);
//     }
//     try {
//       let response = await getContactListServ(payload);
//       setList(response?.data?.data);
//       setStatics(response?.data?.documentCount);
//     } catch (error) {}
//     setShowSkelton(false);
//   };
//   const staticsArr = [
//     {
//       title: "User Queries",
//       count: statics?.userQueries,
//       bgColor: "#6777EF",
//     },
//   ];
//   useEffect(() => {
//     handleGetContactListFunc();
//   }, [payload]);
  
  
  
//   const renderCategory = (category) => {
//     if (category == "user") {
//       return (
//         <button
//           className="badge"
//           style={{ height: "30px", background: "#6777EF", border: "none" }}
//         >
//           User
//         </button>
//       );
//     }
//     if (category == "driver") {
//       return (
//         <button
//           className="badge"
//           style={{ height: "30px", background: "#63ED7A", border: "none" }}
//         >
//           Driver
//         </button>
//       );
//     }
//     if (category == "vender") {
//       return (
//         <button
//           className="badge"
//           style={{ height: "30px", background: "#FFA426", border: "none" }}
//         >
//           Vendor
//         </button>
//       );
//     }
//   };
//   return (
//     <div className="bodyContainer">
//       <Sidebar selectedMenu="System Support" selectedItem="Contact Query" />
//       <div className="mainContainer">
//         <TopNav />
//         <div className="p-lg-4 p-md-3 p-2">
//           <div
//             className="row mx-0 p-0"
//             style={{
//               position: "relative",
//               top: "-75px",
//               marginBottom: "-75px",
//             }}
//           >
//             {staticsArr?.map((v, i) => {
//               return (
//                 <div className="col-md-4 col-12 ">
//                   <div className="topCard shadow-sm py-4 px-3 rounded mb-3">
//                     <div className="d-flex align-items-center ">
//                       <div
//                         className="p-2 shadow rounded"
//                         style={{ background: v?.bgColor }}
//                       >
//                         <img src="https://cdn-icons-png.flaticon.com/128/666/666120.png" />
//                       </div>
//                       <div className="ms-3">
//                         <h6>{v?.title}</h6>
//                         <h2 className="text-secondary">{v?.count}</h2>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               );
//             })}
//           </div>
//           <div className="row m-0 p-0 d-flex align-items-center my-4 justify-content-between topActionForm">
//             <div className="col-lg-3 mb-2 col-md-12 col-12">
//               <h3 className="mb-0 text-bold text-secondary">Contact Queries</h3>
//             </div>
          
//             <div className="col-lg-5 mb-2  col-md-6 col-12">
//               <div>
//                 <select
//                   className="form-control borderRadius24"
//                   onChange={(e) =>
//                     setPayload({ ...payload, category: e.target.value })
//                   }
//                 >
//                   <option value="">Select Category</option>
//                   <option value="user">User</option>
//                   <option value="vender">Vendor</option>
//                   <option value="driver">Driver</option>
//                 </select>
//               </div>
//             </div>
            
//           </div>
//           <div className="mt-3">
//             <div className="card-body px-2">
//               <div className="table-responsive table-invoice">
//                 <table className="table">
//                   <tbody>
//                     <tr style={{ background: "#F3F3F3", color: "#000" }}>
//                       <th
//                         className="text-center py-3"
//                         style={{ borderRadius: "30px 0px 0px 30px" }}
//                       >
//                         Sr. No
//                       </th>
//                       <th className="text-center py-3">First Name</th>
//                       <th className="text-center py-3">Last Name</th>
//                       <th className="text-center py-3">Contact Number</th>
//                       <th className="text-center py-3">Message</th>

//                       <th
//                         className="text-center py-3 "
//                         style={{ borderRadius: "0px 30px 30px 0px" }}
//                       >
//                         Category
//                       </th>
//                     </tr>
//                     <div className="py-2"></div>
//                     {showSkelton
//                       ? [1, 2, 3, 4, 5, 6, 7, 8, 9]?.map((v, i) => {
//                           return (
//                             <>
//                               <tr key={i}>
//                                 <td className="text-center">
//                                   <Skeleton width={50} height={50} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>

//                                 <td className="text-center">
//                                   <Skeleton width={100} height={25} />
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })
//                       : list?.map((v, i) => {
//                           return (
//                             <>
//                               <tr>
//                                 <td className="text-center">{i + 1}</td>

//                                 <td className="font-weight-600 text-center">
//                                   {v?.firstName}
//                                 </td>
//                                 <td className="font-weight-600 text-center">
//                                   {v?.lastName}
//                                 </td>
//                                 <td className="font-weight-600 text-center">
//                                   {v?.contactNumber}
//                                 </td>
//                                 <td className="font-weight-600 text-center d-flex justify-content-center">
//                                   <div
//                                     className="bg-dark text-light p-2"
//                                     style={{
//                                       width: "300px",
//                                       borderRadius: "12px",
//                                     }}
//                                   >
//                                     <h6>{v?.subject}</h6>
//                                     <p className="mb-0">{v?.message}</p>
//                                   </div>
//                                 </td>
//                                 <td className="text-center">
//                                   {renderCategory(v?.category)}
//                                 </td>
//                               </tr>
//                               <div className="py-2"></div>
//                             </>
//                           );
//                         })}
//                   </tbody>
//                 </table>
//                 {list.length == 0 && !showSkelton && <NoRecordFound />}
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
     
     
//     </div>
//   );
// }

// export default ContactQueryList;


import React, { useState, useEffect } from "react";
import Sidebar from "../../../Components/Sidebar";
import TopNav from "../../../Components/TopNav";
import { getContactListServ } from "../../../services/support.service";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import NoRecordFound from "../../../Components/NoRecordFound";

/* ─── Scoped Styles ───────────────────────── */
const styles = `
  .cq-page {
    background: #f5f5f7;
    min-height: 100%;
    padding: 28px;
    font-family: 'Segoe UI', sans-serif;
  }

  /* stat card */
  .cq-stat-grid {
    display: grid;
    grid-template-columns: repeat(1, 320px);
    gap: 18px;
    margin-bottom: 22px;
  }

  @media (max-width: 768px) {
    .cq-stat-grid {
      grid-template-columns: 1fr;
    }
  }

  .cq-stat-card {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 20px;
    display: flex;
    align-items: center;
    gap: 15px;
  }

  .cq-stat-icon {
    width: 58px;
    height: 58px;
    border-radius: 16px;
    background: #fdf2f1;
    color: #a60808;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    flex-shrink: 0;
  }

  .cq-stat-title {
    font-size: 15px;
    color: #888;
    margin-bottom: 6px;
    font-weight: 500;
  }

  .cq-stat-count {
    font-size: 32px;
    font-weight: 700;
    color: #1c0a0a;
    line-height: 1;
  }

  /* toolbar */
  .cq-toolbar {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    padding: 18px 22px;
    margin-bottom: 18px;

    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    flex-wrap: wrap;
  }

  .cq-toolbar-title {
    font-size: 19px;
    font-weight: 700;
    color: #1c0a0a;
  }

  .cq-filter-wrap {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
  }

  .cq-select {
    height: 48px;
    min-width: 240px;
    border-radius: 12px;
    border: 1px solid #f0eded;
    background: #fafafa;
    padding: 0 14px;
    font-size: 15px;
    color: #444;
    outline: none;
    transition: all 0.18s ease;
    cursor: pointer;
  }

  .cq-select:focus {
    border-color: #f0c0b8;
    background: #fff;
  }

  @media (max-width: 768px) {
    .cq-select {
      width: 100%;
    }

    .cq-filter-wrap {
      width: 100%;
    }
  }

  /* table */
  .cq-table-wrap {
    background: #fff;
    border-radius: 16px;
    border: 1px solid #f0eded;
    overflow: hidden;
  }

  .cq-table-scroll {
    overflow-x: auto;
  }

  .cq-table {
    width: 100%;
    border-collapse: collapse;
    min-width: 1200px;
  }

  .cq-table thead tr {
    background: #fdf2f1;
  }

  .cq-table th {
    padding: 18px 20px;
    text-align: left;
    font-size: 14px;
    font-weight: 700;
    color: #a60808;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    white-space: nowrap;
  }

  .cq-table td {
    padding: 20px;
    color: #444;
    border-top: 1px solid #f7f5f5;
    vertical-align: middle;
    font-size: 16px;
  }

  .cq-table tbody tr:hover td {
    background: #fdfafa;
  }

  .cq-serial {
    color: #999;
    font-weight: 600;
    width: 80px;
  }

  .cq-user-cell {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .cq-avatar {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background: #fdf2f1;
    color: #a60808;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 700;
    flex-shrink: 0;
  }

  .cq-name {
    font-size: 16px;
    font-weight: 600;
    color: #222;
  }

  .cq-phone {
    font-size: 15px;
    color: #666;
    font-weight: 500;
  }

  .cq-message-box {
    background: #fafafa;
    border: 1px solid #f0eded;
    border-radius: 14px;
    padding: 14px;
    max-width: 340px;
  }

  .cq-message-subject {
    font-size: 15px;
    font-weight: 700;
    color: #222;
    margin-bottom: 7px;
  }

  .cq-message-text {
    font-size: 14px;
    color: #666;
    line-height: 1.7;
    margin: 0;
  }

  .cq-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 7px 16px;
    border-radius: 30px;
    font-size: 13px;
    font-weight: 600;
    text-transform: capitalize;
    border: none;
  }

  .cq-user {
    background: #e8efff;
    color: #3557d6;
  }

  .cq-driver {
    background: #e7f8ec;
    color: #23944b;
  }

  .cq-vendor {
    background: #fff1df;
    color: #d98200;
  }

  .cq-empty {
    padding: 45px 20px;
  }
`;

function ContactQueryList() {
  const [list, setList] = useState([]);
  const [statics, setStatics] = useState(null);

  const [payload, setPayload] = useState({
    searchKey: "",
    category: "",
    pageNo: 1,
    pageCount: 25,
    sortByField: "",
  });

  const [showSkelton, setShowSkelton] = useState(false);

  const handleGetContactListFunc = async () => {
    if (list.length === 0) {
      setShowSkelton(true);
    }

    try {
      let response = await getContactListServ(payload);

      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);

    } catch (error) {
      toast.error("Failed to fetch contact queries");
    }

    setShowSkelton(false);
  };

  useEffect(() => {
    handleGetContactListFunc();
  }, [payload]);

  // INITIALS
  const getInitials = (firstName = "", lastName = "") => {
    return `${firstName?.[0] || ""}${lastName?.[0] || ""}`
      .toUpperCase();
  };

  // CATEGORY BADGE
  const renderCategory = (category) => {

    if (category === "user") {
      return (
        <span className="cq-badge cq-user">
          User
        </span>
      );
    }

    if (category === "driver") {
      return (
        <span className="cq-badge cq-driver">
          Driver
        </span>
      );
    }

    if (category === "vender") {
      return (
        <span className="cq-badge cq-vendor">
          Vendor
        </span>
      );
    }

    return "N/A";
  };

  // STATICS
  const staticsArr = [
    {
      title: "User Queries",
      count: statics?.userQueries || list?.length || 0,
    },
  ];

  return (
    <div className="bodyContainer">

      <style>{styles}</style>

      <Sidebar
        selectedMenu="System Support"
        selectedItem="Contact Query"
      />

      <div className="mainContainer">

        <TopNav
          pageTitle="Contact Queries"
          pagePath="Home / System Support / Contact Query"
        />

        <div className="cq-page">

          {/* ── Stat Card ── */}
          <div className="cq-stat-grid">

            {staticsArr?.map((v, i) => (
              <div className="cq-stat-card" key={i}>

                <div className="cq-stat-icon">
                  <i className="ti ti-message-circle" />
                </div>

                <div>
                  <div className="cq-stat-title">
                    {v?.title}
                  </div>

                  <div className="cq-stat-count">
                    {v?.count}
                  </div>
                </div>

              </div>
            ))}

          </div>

          {/* ── Toolbar ── */}
          <div className="cq-toolbar">

            <div className="cq-toolbar-title">
              Contact Queries
            </div>

            <div className="cq-filter-wrap">

              <select
                className="cq-select"
                onChange={(e) =>
                  setPayload({
                    ...payload,
                    category: e.target.value,
                  })
                }
              >
                <option value="">
                  Select Category
                </option>

                <option value="user">
                  User
                </option>

                <option value="vender">
                  Vendor
                </option>

                <option value="driver">
                  Driver
                </option>
              </select>

            </div>

          </div>

          {/* ── Table ── */}
          <div className="cq-table-wrap">

            <div className="cq-table-scroll">

              <table className="cq-table">

                <thead>
                  <tr>
                    <th>#</th>
                    <th>User</th>
                    <th>Contact Number</th>
                    <th>Message</th>
                    <th>Category</th>
                  </tr>
                </thead>

                <tbody>

                  {/* Skeleton */}
                  {showSkelton ? (
                    [...Array(8)].map((_, i) => (
                      <tr key={i}>

                        {[1, 2, 3, 4, 5].map((v) => (
                          <td key={v}>
                            <Skeleton height={24} />
                          </td>
                        ))}

                      </tr>
                    ))
                  ) : list?.length > 0 ? (
                    list?.map((v, i) => (
                      <tr key={v?._id || i}>

                        {/* SERIAL */}
                        <td className="cq-serial">
                          {i + 1}
                        </td>

                        {/* USER */}
                        <td>

                          <div className="cq-user-cell">

                            <div className="cq-avatar">
                              {getInitials(
                                v?.firstName,
                                v?.lastName
                              )}
                            </div>

                            <div className="cq-name">
                              {v?.firstName} {v?.lastName}
                            </div>

                          </div>

                        </td>

                        {/* CONTACT */}
                        <td>

                          <div className="cq-phone">
                            {v?.contactNumber || "N/A"}
                          </div>

                        </td>

                        {/* MESSAGE */}
                        <td>

                          <div className="cq-message-box">

                            <div className="cq-message-subject">
                              {v?.subject || "No Subject"}
                            </div>

                            <p className="cq-message-text">
                              {v?.message || "No message available"}
                            </p>

                          </div>

                        </td>

                        {/* CATEGORY */}
                        <td>
                          {renderCategory(v?.category)}
                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="5"
                        className="cq-empty"
                      >
                        <NoRecordFound />
                      </td>
                    </tr>
                  )}

                </tbody>

              </table>

            </div>

          </div>

        </div>
      </div>
    </div>
  );
}

export default ContactQueryList;